import { render } from "./WhatsAppFloat.vue?vue&type=template&id=41775bf8&scoped=true"
import script from "./WhatsAppFloat.vue?vue&type=script&lang=js"
export * from "./WhatsAppFloat.vue?vue&type=script&lang=js"

import "./WhatsAppFloat.vue?vue&type=style&index=0&id=41775bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41775bf8"]])

export default __exports__